import { useLayoutEffect, useState, useEffect } from 'react';
import { useScroll } from '@eti/utils';
import { SEARCH_RESULT_SIDEBAR_HEIGHT_EVENT } from '../../../constants/customEventConstants';
import { subscribe, unsubscribe } from '../../../utils/customEvent';

const getCartPositionFromContainerTop = (innerRef, containerRef) => {
  const cartDomElement = innerRef?.current?.getBoundingClientRect();
  const containerDomElement = containerRef?.current?.getBoundingClientRect();

  if (cartDomElement && containerDomElement) {
    return Math.abs(containerDomElement.y - cartDomElement.y);
  }

  return 0;
};
let isSidebarClicked = false;

const useStickySidebar = (siteHeaderHeight, innerRef, containerRef) => {
  const [sidebarStyles, setSidebarStyles] = useState(null);
  const [topStyles, setTopStyles] = useState(null);
  const [isSidebarHeightUpdated, setUpdateSidebarHeight] = useState(false);
  const { isScrollingDown, isScrollingUp } = useScroll();

  const topAndBottomMargin = 20;
  const cartHeight = innerRef?.current?.getBoundingClientRect().height;
  const viewportIsTallerThanCart = window.innerHeight - siteHeaderHeight > cartHeight;

  useEffect(() => {
    const sidebarListener = () => {
      isSidebarClicked = true;
      setUpdateSidebarHeight((prevUpdate) => !prevUpdate);
    };
    subscribe(SEARCH_RESULT_SIDEBAR_HEIGHT_EVENT, sidebarListener);

    return () => {
      unsubscribe(SEARCH_RESULT_SIDEBAR_HEIGHT_EVENT, sidebarListener);
    };
  }, []);

  useLayoutEffect(() => {
    const cartMarginTop = getCartPositionFromContainerTop(innerRef, containerRef);
    const viewportAndCartOverlap = window.innerHeight - cartHeight - topAndBottomMargin;

    // cart is shorter than viewport – make it stick to the top.
    if (viewportIsTallerThanCart) {
      setTopStyles({ marginTop: 0 });
      setSidebarStyles({
        top: `${siteHeaderHeight + topAndBottomMargin}px`,
      });
    }

    // cart is taller than the viewport, but it’s at the top of the page = don’t set a margin.
    if (cartMarginTop === 0 && !viewportIsTallerThanCart) {
      setTopStyles({ marginTop: `${cartMarginTop}px` });
    }

    // cart is taller than the viewport – have it scroll up/down as the user scrolls.
    if (!viewportIsTallerThanCart) {
      if (isScrollingDown) {
        setSidebarStyles({
          top: `${viewportAndCartOverlap}px`,
        });

        if (cartMarginTop !== 0) {
          setTopStyles({ marginTop: `${cartMarginTop}px` });
        }
      }

      if (isScrollingUp) {
        setTopStyles({ marginTop: `${cartMarginTop}px` });
        if (!isSidebarClicked) {
          setSidebarStyles({
            bottom: `-${Math.abs(viewportAndCartOverlap - siteHeaderHeight)}px`,
          });
        }
      }
    }
    isSidebarClicked = false;
  }, [
    innerRef,
    containerRef,
    cartHeight,
    isScrollingDown,
    isScrollingUp,
    siteHeaderHeight,
    viewportIsTallerThanCart,
    isSidebarHeightUpdated,
  ]);

  return { sidebarStyles, topStyles };
};

export default useStickySidebar;
